import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '../../../shared/material.module';
import { DatePipe } from '@angular/common';

import * as FusionCharts from "fusioncharts";
import * as Charts from "fusioncharts/fusioncharts.charts";
import * as FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import { FusionChartsModule } from "angular-fusioncharts";
import { GetWidgetsService } from './get-widgets.service';
import { BucketPerformanceOnBudgetWidgetComponent } from './components/bucket-performance-on-budget-widget/bucket-performance-on-budget-widget.component';
import { CostPerHourWidgetComponent } from './components/cost-per-hour-widget/cost-per-hour-widget.component';
import { CostPerTonWidgetComponent } from './components/cost-per-ton-widget/cost-per-ton-widget.component';
import { CostPerBcmWidgetComponent } from './components/cost-per-bcm-widget/cost-per-bcm-widget.component';
import { InspectionCountPerJobsiteWidgetComponent } from './components/inspection-count-per-jobsite-widget/inspection-count-per-jobsite-widget.component';
import { EnlargeGetDashboardWidgetComponent } from './components/enlarge-get-dashboard-widget/enlarge-get-dashboard-widget.component';

FusionChartsModule.fcRoot(FusionCharts, Charts, FusionTheme);

@NgModule({
    imports: [
        CommonModule,
        FusionChartsModule.forRoot(FusionCharts, Charts),
        MaterialModule
    ],
    declarations: [
        BucketPerformanceOnBudgetWidgetComponent,
        CostPerHourWidgetComponent,
        CostPerTonWidgetComponent,
        CostPerBcmWidgetComponent,
        InspectionCountPerJobsiteWidgetComponent,
        EnlargeGetDashboardWidgetComponent,
    ],

    exports: [
        BucketPerformanceOnBudgetWidgetComponent,
        CostPerHourWidgetComponent,
        CostPerTonWidgetComponent,
        CostPerBcmWidgetComponent,
        InspectionCountPerJobsiteWidgetComponent,
    ],
    providers: [
        GetWidgetsService,
        DatePipe
    ]
})
export class GETWidgetsModule { }
